import React, { useEffect, useRef } from "react";
import { IoVolumeHighOutline, IoVolumeLowOutline, IoVolumeMediumOutline, IoVolumeMuteOutline } from "react-icons/io5";

const VolumeBar = ({ volume, onVolumeChange, showVolume, setShowVolume }) => {
  const volumeRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (volumeRef.current && !volumeRef.current.contains(event.target)) setShowVolume(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setShowVolume]);

  const getVolumeIcon = () => {
    if (volume === 0) return <IoVolumeMuteOutline size={19} />;
    if (volume <= 0.33) return <IoVolumeLowOutline size={19} />;
    if (volume <= 0.66) return <IoVolumeMediumOutline size={19} />;
    return <IoVolumeHighOutline size={19} />;
  };

  const volumePercentage = Math.max(0, Math.min(volume, 1)) * 100;

  return (
    <div ref={volumeRef} className="relative flex items-center" onMouseEnter={() => setShowVolume(true)} onMouseLeave={() => setShowVolume(false)}>
      <button
        type="button"
        onClick={() => setShowVolume(!showVolume)}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-white transition-all duration-200 hover:bg-white/10 active:scale-95"
        aria-label="Volume"
      >
        {getVolumeIcon()}
      </button>

      <div className={`flex items-center overflow-hidden transition-all duration-300 ease-out ${showVolume ? "ml-1 w-24 opacity-100" : "ml-0 w-0 opacity-0"}`}>
        <input
          type="range"
          min={0}
          max={1}
          step={0.01}
          value={volume}
          onChange={(e) => onVolumeChange(Number(e.target.value))}
          className="h-1 w-24 shrink-0 cursor-pointer appearance-none rounded-full [&::-webkit-slider-runnable-track]:h-1 [&::-webkit-slider-runnable-track]:rounded-full [&::-webkit-slider-runnable-track]:bg-transparent [&::-webkit-slider-thumb]:mt-[-4px] [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-white [&::-webkit-slider-thumb]:shadow [&::-moz-range-track]:h-1 [&::-moz-range-track]:rounded-full [&::-moz-range-track]:bg-transparent [&::-moz-range-thumb]:h-3 [&::-moz-range-thumb]:w-3 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:bg-white"
          style={{
            background: `linear-gradient(to right, #8b5cf6 0%, #8b5cf6 ${volumePercentage}%, rgba(255,255,255,.35) ${volumePercentage}%, rgba(255,255,255,.35) 100%)`,
          }}
          aria-label="Volume slider"
        />
      </div>
    </div>
  );
};

export default VolumeBar;